import React from 'react'
import BaseIcon from 'react-icon-base'

const Logout = () => (
  <BaseIcon width="22" height="24" viewBox="0 0 22 24">
    <title>Logout</title>
    <path
      d="M16.107 17.518v-3.45H7.94v-4.6h8.167v-3.45l5.833 5.75-5.833 5.75M13.773.268c1.289 0 2.334 1.03 2.334 2.3v2.3h-2.334v-2.3h-10.5v18.4h10.5v-2.3h2.334v2.3c0 1.27-1.045 2.3-2.334 2.3h-10.5c-1.288 0-2.333-1.03-2.333-2.3v-18.4c0-1.27 1.045-2.3 2.333-2.3h10.5z"
      fill="#85A4B0"
      fillRule="nonzero"
    />
  </BaseIcon>
)

export default Logout
